import YFormInput from './Input';

export { YFormInput };
export default YFormInput;
